module.exports = __webpack_public_path__ + "img/P52-zh.be2cf7b9.png";